var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hotel-list-regions filter",
      attrs: { "data-component": "hotel-list-regions-filter" },
    },
    [
      _c(
        "div",
        {
          staticClass: "filter-items",
          attrs: {
            role: "tablist",
            "aria-label": _vm.tc("accessibility.filterByRegion"),
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "filter-item tab-group-button",
              class: [{ active: _vm.selectedRegion === null }],
              attrs: {
                id: "all-regions",
                role: "tab",
                "aria-selected": _vm.selectedRegion === null,
                tabindex: _vm.selectedRegion === null ? "0" : "-1",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.triggerFilter(null, $event)
                },
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.triggerFilter(null, $event)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "left", 37, $event.key, [
                        "Left",
                        "ArrowLeft",
                      ])
                    ) {
                      return null
                    }
                    if ("button" in $event && $event.button !== 0) {
                      return null
                    }
                    $event.preventDefault()
                    _vm.triggerFilter(
                      _vm.getRegionByIndex(_vm.regions.length - 1),
                      $event
                    )
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "right", 39, $event.key, [
                        "Right",
                        "ArrowRight",
                      ])
                    ) {
                      return null
                    }
                    if ("button" in $event && $event.button !== 2) {
                      return null
                    }
                    $event.preventDefault()
                    _vm.triggerFilter(_vm.getRegionByIndex(0), $event)
                  },
                ],
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.tc("booking.allRegions")) + "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.regions, function (region, i) {
            return _c(
              "button",
              {
                key: i,
                staticClass: "filter-item tab-group-button",
                class: [{ active: _vm.selectedRegion === region }],
                attrs: {
                  id: "region-" + i,
                  role: "tab",
                  "aria-selected": _vm.selectedRegion === region,
                  tabindex: _vm.selectedRegion === region ? "0" : "-1",
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.triggerFilter(region, $event)
                  },
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.triggerFilter(region, $event)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "left", 37, $event.key, [
                          "Left",
                          "ArrowLeft",
                        ])
                      ) {
                        return null
                      }
                      if ("button" in $event && $event.button !== 0) {
                        return null
                      }
                      $event.preventDefault()
                      _vm.triggerFilter(_vm.getRegionByIndex(i - 1), $event)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "right", 39, $event.key, [
                          "Right",
                          "ArrowRight",
                        ])
                      ) {
                        return null
                      }
                      if ("button" in $event && $event.button !== 2) {
                        return null
                      }
                      $event.preventDefault()
                      _vm.triggerFilter(_vm.getRegionByIndex(i + 1), $event)
                    },
                  ],
                },
              },
              [_vm._v("\n      " + _vm._s(region) + "\n    ")]
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }